import { useEffect } from "react";
import { setDocumentTitle } from "@/lib/documentTitle";
import { R1DashboardProvider } from "@/features/R1Dashboard/context/R1DashboardProvider";
import PeFundsView from "@/features/R1Dashboard/views/PeFundsView";

export default function R1PeFunds() {
  useEffect(() => {
    setDocumentTitle("Quantilia | PE Funds");
  }, []);

  return (
    <R1DashboardProvider>
      <main className="min-h-0 flex flex-1 flex-col overflow-auto bg-white p-5">
        <PeFundsView />
      </main>
    </R1DashboardProvider>
  );
}
